var _style, _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBank06(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#008FBE;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 50,
    cy: 50,
    r: 50
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,38.5c0.3-0.2,0.5-0.2,0.6-0.3c2.3-1.5,4.5-3.1,6.8-4.6c1.9-1.3,3.7-2.6,5.7-3.9c1.9-1.2,3.8-2.4,5.7-3.5 c2.4-1.4,4.6-1.1,6.9,0.5c2.2,1.6,4.2,3.5,6.1,5.5c0.2,0.2,0.4,0.7,0.4,1c0,0.2-0.4,0.6-0.5,0.6c-2.6-0.2-4.5,1.1-6.5,2.5 c-2.3,1.7-4.6,3.3-6.9,4.9c1.3,1.7,2.5,3.4,3.8,5.1c1.3,1.7,2.5,3.4,3.8,5.1c1.5,2.1,3.1,4.1,4.6,6.1c0.8,1,1.6,2,1.5,3.4 c-0.2,1.9-1.6,3.8-3.8,3.8c-2.8-0.1-5.5,0-8.3,0c-0.5,0-0.9-0.2-1.3-0.6c-0.9-1.2-1.7-2.4-2.6-3.6c-1.2-1.6-2.3-3.2-3.5-4.8 c-1.2-1.7-2.4-3.3-3.6-5c-0.4-0.5-0.8-1-1.1-1.5c-0.2-0.3-0.4-0.3-0.7-0.1c-2.1,1.5-4.2,2.9-6.3,4.4c-0.6,0.4-0.8,0.8-0.8,1.6 c0,2.9,0,5.8,0,8.6c0,0.9,0,0.9-1,0.9c-3.9,0-7.8,0-11.7,0c-0.5,0-1,0.1-1.5,0.1c-0.3,0-0.5-0.1-0.4-0.4c0.1-0.4,0.1-0.9,0.1-1.3 c0-10.6,0-21.1,0-31.7c0-2.3,1-4.1,2.8-5.4c2-1.5,3.9-2.9,6-4.2c1.7-1,3.5-1.8,5.2-2.7c0.3-0.1,0.8-0.1,1,0.1 c0.2,0.2,0.2,0.7,0.1,1c-0.4,0.9-0.5,1.8-0.5,2.7c0,4.8,0,9.6,0,14.4C42.5,37.9,42.5,38.2,42.5,38.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.9,80.7c-4.2,0-8.4,0-12.6,0c-2.8,0-5.2-0.9-7.4-2.5c-2.4-1.8-4.4-4-6.2-6.4c-0.7-0.9-1.4-1.9-2-2.9 c-0.2-0.3-0.2-0.8-0.1-1.2c0.1-0.7,0.8-1,1.5-0.7c1.3,0.6,2.6,0.7,3.9,0.7c15.6,0,31.1,0,46.7,0c0.9,0,1.8-0.3,2.7-0.6 c0.5-0.2,1.1-0.4,1.5,0.1c0.5,0.5,0.7,1,0.3,1.7c-0.7,1-1.3,2.1-2.2,3.1c-1.8,2-3.6,4-5.6,5.8c-1.6,1.5-3.5,2.5-5.7,2.7 c-1.1,0.1-2.3,0.2-3.4,0.3C57.5,80.7,53.7,80.7,49.9,80.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBank06);
export default __webpack_public_path__ + "static/media/icon-bank-06.7367e48859b12048a0ef1af7c578395c.svg";
export { ForwardRef as ReactComponent };